import React from 'react';
import { Moon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-navy-950 pt-10 pb-16 px-4 border-t border-navy-800" data-id="element-121">
      <div className="max-w-6xl mx-auto text-center" data-id="element-122">
        <div className="flex items-center justify-center space-x-2 text-yellow-400 font-serif font-bold text-2xl mb-6 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-123">
          <Moon className="w-6 h-6" data-id="element-124" />
          <span data-id="element-125">MUNDO PRÁCTICO™</span>
        </div>

        <p className="text-white max-w-md mx-auto mb-2" data-id="element-126">
          El sistema de sueño infantil N°1 para familias argentinas con bebés de
          4 a 24 meses.
        </p>
        <p className="text-gray-200 italic mb-12" data-id="element-127">
          Porque criar a tu bebé no debería costarte todas las noches del año.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-white mb-12" data-id="element-128">
          <a href="mailto:mundopractico.oficial@gmail.com" className="hover:text-yellow-400 transition-colors" data-id="element-129">
            📧 mundopractico.oficial@gmail.com
          </a>
          <a href="https://mundopractico.online" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-130">
            🌐 mundopractico.online
          </a>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col items-center" data-id="element-131">
          <p className="text-xs text-gray-300 mb-6" data-id="element-132">
            © Mundo Práctico™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-yellow-400 font-serif italic text-xl md:text-2xl mt-2 drop-shadow-[0_0_15px_rgba(250,204,21,0.3)]" data-id="element-133">
            🌙 "La próxima madrugada puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
};